module.exports = __webpack_public_path__ + "static/media/IMG-1.b7c50c06.jpg";